define(['jquery', 'jquery.transit', 'modernizr', 'container', 'preloader', 'jump'],
    function ($, transit, modernizr, container, preloader, jumpFactory) {

        return (function () {

            const name = 'module-faq';

            const model = container.getBaseModel(name);
            const view = container.getBaseView(name);
            const pubSub = container.getPublishSubscribe();
            const jump = jumpFactory.create();
            /* model */

            model.publicVars = {};

            model.privateVars = {

            };

            model.methods = {

            };

            /* view */

            view.publicVars = {};

            view.privateVars = {
                anim: false
            };

            view.startup = function () {

            };

            view.bind = function () {
                $(view.publicVars.cssId.faqItemLabelCls).click(function () {
                    const id = container.getData($(this)[0], 'id');

                    if(!view.privateVars.anim) {

                        view.privateVars.anim = true;

                        if (!$(this).hasClass(view.publicVars.cssId.isActiveCls.substr(1))) {
                            view.methods.openItem(id);
                        } else {
                            view.methods.closeItem(id);
                        }
                    }
                });
            };

            view.methods = {
                openItem: function (id) {
                    const headerHeight = $(view.publicVars.cssId.headerCls).outerHeight();

                    $(view.publicVars.cssId.faqItemLabelCls + id).addClass(view.publicVars.cssId.isActiveCls.substr(1));
                    $(view.publicVars.cssId.faqItemContentCls + id).css({display: 'block'});
                    jump.centerTo(view.publicVars.cssId.faqItemContentCls + id, null, {
                        modifier: - parseInt(headerHeight)
                    });
                    $(view.publicVars.cssId.faqItemContentCls + id).css({display: 'none'});
                    $(view.publicVars.cssId.faqItemContentCls + id).slideDown(300, function () {
                        view.privateVars.anim = false;
                    });
                    $(view.publicVars.cssId.faqItemLabelArrowCls + id + view.publicVars.cssId.isDownCls).css({ display: 'none'});
                    $(view.publicVars.cssId.faqItemLabelArrowCls + id + view.publicVars.cssId.isUpCls).css({ display: 'block'});
                },

                closeItem: function (id) {
                    $(view.publicVars.cssId.faqItemLabelCls + id).removeClass(view.publicVars.cssId.isActiveCls.substr(1));
                    $(view.publicVars.cssId.faqItemContentCls + id).slideUp(300, function () {
                        view.privateVars.anim = false;
                    });
                    $(view.publicVars.cssId.faqItemLabelArrowCls + id + view.publicVars.cssId.isUpCls).css({ display: 'none'});
                    $(view.publicVars.cssId.faqItemLabelArrowCls + id + view.publicVars.cssId.isDownCls).css({ display: 'block'});
                }
            };

            /* custom events */
            //pubSub.subscribe('view/actionShowCharacter', view.methods.actionShowCharacter);
            //pubSub.subscribe('view/showThx', view.methods.showThx);


            /* public methods */
            return {
                init: function (options) {
                    model.init(options);
                    view.init(options);
                }
            };


        })();

    });
